/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ListingsInputs */

const cs_nav_listings = /** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const en_nav_listings = /** @type {(inputs: Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Nav_ListingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_listings = /** @type {((inputs?: Nav_ListingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ListingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_listings(inputs)
	return cs_nav_listings(inputs)
});